import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SkeletonBlock = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'w' && prop !== 'h' && prop !== 'r',
})<{ w: string | number; h: string | number; r: number }>(
	({ theme, w, h, r }) => ({
		background: theme.palette.neutral[40],
		height: h,
		width: w,
		borderRadius: r,
		animation: `skeletonAnimation 1.5s infinite ease`,

		'@keyframes skeletonAnimation': {
			'0%': {
				opacity: 1,
			},
			'50%': {
				opacity: 0.3,
			},
			'100%': {
				opacity: 1,
			},
		},
	})
);
